var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessequalsOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1648 1.82918C11.5352 1.64393 11.9857 1.7941 12.171 2.16459C12.3562 2.53507 12.2061 2.98557 11.8356 3.17082L5.17722 6.5L11.8356 9.82918C12.2061 10.0144 12.3562 10.4649 12.171 10.8354C11.9857 11.2059 11.5352 11.3561 11.1648 11.1708L4.05918 7.61803C3.13787 7.15738 3.13787 5.84262 4.05918 5.38196L11.1648 1.82918ZM3.16475 10.1708C2.79427 9.98557 2.6441 9.53507 2.82934 9.16459C3.01459 8.7941 3.46509 8.64393 3.83557 8.82918L11.8356 12.8292C12.2061 13.0144 12.3562 13.4649 12.171 13.8354C11.9857 14.2059 11.5352 14.3561 11.1648 14.1708L3.16475 10.1708Z",
    fill: "#7B868C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessequalsOutline16);
export default __webpack_public_path__ + "static/media/lessequals_outline_16.370fe260f6f7b5520fcfb5cb39eb33a1.svg";
export { ForwardRef as ReactComponent };